import { reducer as earlyBirdOfferBuilder } from "app/pages/EarlyBirdOfferBuilder/modules/EarlyBirdOfferBuilder";

export const reducers = {
    earlyBirdOfferBuilder,
};